import React, { forwardRef,} from 'react'
import { FiExternalLink } from "react-icons/fi";
import { FaGithub } from "react-icons/fa";

const Projects = forwardRef(({ darkMode }, ref) => {  
    const MyProjects = [
        {
            name: "Lava Services",
            title: "Responsive single page",
            description: "Transforming ideas into powerful digital experiences with cutting-edge web solutions",
            image: "img/lavawebsite.jpeg",
            vercel: "https://lava-single-page-website.vercel.app/",
            github: "https://github.com/a7medelgaml/Lava-single-page-website/",
        },
        {
            name: "Fashion Wear",
            title: "Responsive E-commerce Website",
            description: "Built using React with an API-powered cart for a seamless shopping experience.",
            image: "img/fashionwebsite.jpeg",
            vercel: "https://fashion-wear-website.vercel.app/",
            github: "https://github.com/a7medelgaml/FashionWear-website/",
        },
        {
            name: "GAM Liker",
            title: "Responsive single page",
            description: "A website designed to boost social media engagement through interactive features and real-time insights.",
            image: "img/likerwebsite.jpeg",
            vercel: "https://gam-liker.vercel.app/",
            github: "https://github.com/a7medelgaml/Gam-Liker/",
        },
        {
            name: "Brainwaves Academy",
            title: "Interactive Learning Platform",
            description: "A responsive Next-based platform with smooth scrolling, multiple pages, API integration, and seamless navigation.",
            image: "img/BWwebsite.jpeg",
            vercel: "https://brainwaves-academy.vercel.app/",
            github: "https://github.com/a7medelgaml/BrainWaves-stem-academy/",
        },
        {
            name: "Trendora",
            title: "Fashion E-commerce Website",
            description: "Responsive fashion e-commerce website built with Next.js. Features shopping cart, dynamic product filtering, and integration with custom API. Users can browse by category, view product details, and add items to cart. Designed for smooth user experience across all devices.",
            image: "img/trendorawebsite.jpeg",
            vercel: "https://trendora-cyan.vercel.app/home",
            github: "https://github.com/a7medelgaml/",
        },
        {
            name: "MG Studio",
            title: "Voice Over Portfolio",
            description: "A clean and responsive Single Page Application (SPA) built with Next.js to showcase a professional voice-over portfolio. Designed for seamless user experience across all devices, highlighting voice samples and contact details elegantly.",
            image: "img/mgstudiowebsite.jpeg",
            vercel: "https://mg-studio-six.vercel.app/",
            github: "https://github.com/a7medelgaml/",
        },
        {
            name: "Factory Management System ",
            title: "Item Management Dashboard for Company Profiles",
            description: "A full-stack dashboard built with Next.js, Prisma, and Cloudinary for managing companies and their items, Admins can view item details, edit content, and manage associated image galleries, Authentication is handled via NextAuth, with role-based access for secure control,Dynamic routing enables SEO-friendly URLs for company and item pages.",
            image: "img/factory.jpeg",
            vercel: "https://quality-system-seven.vercel.app/",
            github: "https://github.com/a7medelgaml/",
        },
        {
            name: "MB Marketing",
            title: "Media Buyer Portfolio",
            description: "A clean and responsive Single Page Application (SPA) built with Next.js to showcase a professional Media Buyer portfolio. Designed for seamless user experience across all devices, highlighting voice samples and contact details elegantly.",
            image: "img/media.jpeg",
            vercel: "https://mediabuyer-portfolio.vercel.app/",
            github: "https://github.com/a7medelgaml/",
        },
    ]
    return (
    <div ref={ref} id="projects">  
        <div className='container-lg my-5 '>
            <div className="row justify-content-center">
                {/* Headline Secton -> Projects */}
                <div className="col-md-12 text-center my-5">
                    <h1 className="text-center projects-header responsive-HXXtext"><span className='highlight' style={{ color: "#c2b41e",}}> Projects</span></h1>
                </div>
                {/* Projects cards */}
                <div className="row justify-content-start mt-5">
                {/* Lava Website  */}
                {MyProjects.map((project) => (
                    <div className="col-sm-6 col-md-4 col-lg-4 d-flex justify-content-center mb-4 " >
                        <div className={` projects  w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>                    
                            <div className="proj-img">
                                <img src={project.image} alt="" className='proj-img-in'/>
                            </div>
                            <div className="proj-tiile ps-1 mt-4">
                                <p className='responsive-Htext fw-bold'>{project.name}</p>
                                <p className='responsive-text text-capitalize'>{project.title} </p>
                                <p className='responsive-Stext mb-5 text-capitalize'>{project.description}</p>
                                <div className="proj-links">
                                    <a href={project.vercel} className='me-2 ' target="_blank" rel="noreferrer"><FiExternalLink size={24} className={`${darkMode ? "col-darkMode" : "col-lightMode"}`}/></a>
                                    <a href={project.github} target="_blank" rel="noreferrer"><FaGithub size={24} className={`${darkMode ? "col-darkMode" : "col-lightMode"}`}/></a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            </div>
        </div>
    </div>
  )
})

export default Projects